import api from './api';

// Types
export interface WalkInRequest {
    clientId?: number;
    clientName?: string;
    barberServiceId: number;
    promotionId?: number;
    assignedBarberIds?: (number | undefined)[];
    notes?: string;
    startDate?: string;
    startTime?: string;
}

export interface WalkInResponse {
    appointmentId: number;
    clientId: number;
    clientDisplayName: string;
    isAnonymous: boolean;
    serviceName: string;
    servicePrice: number;
    status: string;
    createdAt: string;
    message: string;
}

export interface AnonymousClient {
    id: number;
    displayName: string;
    appointmentsCount: number;
    lastVisit: string | null;
    totalSpent: number;
}

export interface ClientSearch {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    isAnonymous: boolean;
    totalAppointments: number;
}

export interface LinkAnonymousRequest {
    anonymousClientId: number;
    targetClientId: number;
}

export interface LinkAnonymousResponse {
    linkedAppointments: number;
    targetClientId: number;
    targetClientName: string;
    message: string;
}

export interface BarberService {
    id: number;
    serviceTypeId: number;
    serviceName: string;
    price: number;
    durationMinutes: number;
}

// Service
export const walkInService = {
    /**
     * Create a walk-in appointment
     */
    async createWalkIn(request: WalkInRequest): Promise<WalkInResponse> {
        const response = await api.post<WalkInResponse>('/barber/walk-in', request);
        return response.data;
    },

    /**
     * Get list of anonymous clients
     */
    async getAnonymousClients(): Promise<AnonymousClient[]> {
        const response = await api.get<AnonymousClient[]>('/barber/walk-in/anonymous-clients');
        return response.data;
    },

    /**
     * Search for registered clients
     */
    async searchClients(query: string): Promise<ClientSearch[]> {
        if (!query || query.length < 2) return [];
        const response = await api.get<ClientSearch[]>(`/barber/walk-in/search-clients?query=${encodeURIComponent(query)}`);
        return response.data;
    },

    /**
     * Link anonymous client to real client
     */
    async linkAnonymous(request: LinkAnonymousRequest): Promise<LinkAnonymousResponse> {
        const response = await api.post<LinkAnonymousResponse>('/barber/walk-in/link-anonymous', request);
        return response.data;
    },

    /**
     * Get barber's offered services
     */
    async getServices(): Promise<BarberService[]> {
        const response = await api.get<BarberService[]>('/barber/walk-in/services');
        return response.data;
    },
    /**
     * Get active promotions
     */
    async getActivePromotions(): Promise<any[]> {
        const response = await api.get<any[]>('/promotions/active');
        return response.data;
    }
};
